import { useQuery } from 'apollo-3';

import { getMPWeeklyLearningProgressWithCapWorkload } from 'GraphQL/query/MyPath.query';

const useGetWeeklyLearningProgressWithCapWorkload = ({ startDate, endDate, ...restProps }) => {
  const { data, loading, error, refetch } = useQuery(getMPWeeklyLearningProgressWithCapWorkload, {
    variables: { startDate, endDate },
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
    ...restProps,
  });

  return {
    weeklyLearningData: data?.mpGetWeeklyLearningProgress?.subjectProgresses || [],
    studentSemestersData: data?.mpGetMyStudentSemesters?.myStudentSemesters || [],
    loading,
    error,
    refetch,
  };
};

export default useGetWeeklyLearningProgressWithCapWorkload;
